import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyInitialTheme } from "@/portal/hooks/useTheme";

// Wave 30 · Phase 7f — Apply persisted/system theme BEFORE first paint
// to avoid the flash-of-wrong-theme on cold load.
applyInitialTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
